import { Condition, SearchState } from "src/search/types";
import { asKey } from "src/utils/fields";
import { ContentViews, SerializableView } from "../explore/lib/useContentView";

export function mergeFilters(
  into: Condition[],
  updates: Condition[]
): Condition[] {
  const merged: Condition[] = [];
  const updateKeys = new Set(updates.map((cond) => asKey(cond)));
  into.forEach((condition) => {
    if (updateKeys.has(asKey(condition))) return;
    merged.push(condition);
  });
  return [...merged, ...updates];
}

export function mergeState(
  into: SearchState,
  updates?: SearchState
): SearchState {
  return {
    orgId: into.orgId,
    aggregations:
      updates &&
      updates.aggregations &&
      Array.isArray(updates.aggregations) &&
      updates.aggregations.length > 0
        ? updates.aggregations
        : into.aggregations,
    compareWith:
      updates &&
      updates.compareWith &&
      Object.keys(updates.compareWith).length > 0
        ? updates.compareWith
        : into.compareWith,
    duration: into.duration || "",
    endDate: into.endDate,
    filters: mergeFilters(into.filters || [], updates?.filters || []),
    groupBys:
      updates &&
      updates.groupBys &&
      Array.isArray(updates.groupBys) &&
      updates.groupBys.length > 0
        ? updates.groupBys
        : into.groupBys,
    search: updates?.search || into.search,
    select:
      updates &&
      updates.select &&
      Array.isArray(updates.select) &&
      updates.select.length > 0
        ? updates.select.slice(0, 1) // only one entity is allowed
        : into.select,
    startDate: into.startDate,
  };
}

// In an ideal runtime, this next section of code wouldn't exist,
// but there is a bug in our tables where it gets stuck with the wrong columns.
//
// So if the current view is a table, we'll set it to the default
// when using a pivot id. Otherwise, we'll let it ride.
//
// When VZBL-1409 is fixed, this code should be removed to see
// if the problem hasn't gone away.
export const getCorrectedContentView = (
  viz: SerializableView,
  pivoting?: boolean
): SerializableView =>
  pivoting && [ContentViews.dataTable, ContentViews.default].includes(viz.value)
    ? { value: ContentViews.default, config: {} }
    : viz;
